import React from 'react'

const WorkspaceContext = React.createContext({})

export default WorkspaceContext
